import { useBoundStore } from '@Store/useBoundStore';
import type { EddQuestion } from '@Store/slices/eddQuestions/createEddEmbeddedSlice';

const normalizeQuestionId = (id: string) => id?.toLowerCase().replace(/_/g, '-') ?? '';

const getEddQuestionIndex = (questionId: string) => {
  const { getEddEmbeddedQuestions } = useBoundStore.getState();
  const normalizedId = normalizeQuestionId(questionId);
  return getEddEmbeddedQuestions().findIndex(
    (question) => normalizeQuestionId(question.questionId) === normalizedId
  );
};

export const getDefaultValueByQuestionId = (questionId: string) => {
  const { getEddEmbeddedQuestions } = useBoundStore.getState();
  const index = getEddQuestionIndex(questionId);
  const answer = getEddEmbeddedQuestions()[index]?.answer;
  if (typeof answer !== 'string') {
    return answer;
  }
  try {
    const parsed = JSON.parse(answer);
    if (Array.isArray(parsed) || (typeof parsed === 'object' && parsed !== null)) {
      return parsed;
    }
    return String(parsed);
  } catch {
    return answer;
  }
};

export const saveEddQuestionToLocalStore = (question: EddQuestion) => {
  const { updateEddEmbeddedQuestions, getEddEmbeddedQuestions } = useBoundStore.getState();
  const rawQuestions = [...getEddEmbeddedQuestions()];
  const index = getEddQuestionIndex(question.questionId);
  if (index !== -1) {
    rawQuestions[index] = question;
  } else {
    rawQuestions.push(question);
  }
  updateEddEmbeddedQuestions(rawQuestions);
};
